import { HttpErrorResponse } from "@angular/common/http";
import { NGXLogger } from "ngx-logger";
import { pipe, throwError } from "rxjs";
import { tap, catchError, map } from "rxjs/operators";
import { IResponse } from "src/models/response.model";
import { convertToLocalString } from "./date-serializer";

// TODO: 예외등의 처리를 맡아서 처리함.
export function handleResponse<T>(logger: NGXLogger, message: string) {
  return pipe(
    tap((res) => logger.log(message, res)),
    catchError(handleError),
    map((data: IResponse) => {
      return data.result as T;
    })
  );
}

export function handleError(error: HttpErrorResponse) {
  if (error.error instanceof ErrorEvent) {
    // A client-side or network error occurred. Handle it accordingly.
    console.error('An error occurred:', error.error.message);
  } else {
    // The backend returned an unsuccessful response code.
    // The response body may contain clues as to what went wrong.
    console.error(
      `Backend returned code ${error.status}, ` +
      `body was: ${error.error}`);
  }
  // Return an observable with a user-facing error message.
  return throwError(
    'Something bad happened; please try again later.');
}

export function genQueryStr(value: any) {
  let params = [];
  for (const property in value) {
    if (value[property] != undefined && value[property] != null) {
      let paramValue = value[property];
      // check is Date?
      // https://stackoverflow.com/questions/643782/how-to-check-whether-an-object-is-a-date
      if (typeof paramValue.getMonth === 'function') {
        paramValue = convertToLocalString(value[property]);
      }

      if (paramValue != '') {
        params.push(`${property}=${paramValue}`);
      }
    }
  };

  return `${params.join('&')}`;
}